import React, { useEffect, useRef, useLayoutEffect } from "react";

import "./Chat.css";
import { getArcConfig } from "../../api/ConfigAPI.js";
import { AzureAPI } from "../../api/AzureAPI.js";
import {
  setChatHeaderTitle,
  setChatSubtitle,
  setChatParmEnableTextArea,
  setChatParmLanguage,
  setChatWidgetOpened,
  setUnreadMessageCount,
  renderChat,
} from "../../redux/actions/chatActions";
import { setError } from "../../redux/actions/errorActions";
import {
  setIsChatEnabled,
  clearMessageList,
  setIsAgentConnected,
  setSoundOff,
  scrubMessageFromInputContainer,
  setMessageToSend,
  resetUnreadNotif,
} from "../../redux/actions/messagePaneActions";
import {
  setChatConnected,
  startConnectParticipant,
  endConnectParticipant,
} from "../../redux/actions/amazonConnectActions";
import { useDispatch } from "react-redux";
import { parseParentMessage, downloadImage } from "../../common/ChatUtil.js";
import { logger } from "../../common/Logger";
import {
  initiateChatMethod,
  uploadChatLogs,
  isAppVersionLatest,
} from "../../api/ChatAPI.js";
import {
  UnKnownError,
  ChatWidgetVersionMismatchError,
  AzureAuthenticationLoginInprogressError,
} from "../../common/CustomError";
import InfoBar from "../InfoBar/InfoBar.js";
import MessageList from "../MessageList/MessageList.js";
import InputContainer from "../InputContainer/InputContainer.js";
import Loader from "../Loader/Loader.js";
import PreChatForm from "../PreChatForm/PreChatForm.js";
import ErrorPage from "../Error/ErrorPage";
import Watermark from "../Watermark/Watermark.js";

import { useMsal, useIsAuthenticated } from "@azure/msal-react";

import { graphConfig, privateChatApi } from "../../authConfig";
import { useTranslation } from "react-i18next";
import { printChatUtility } from "../../common/printChatUtility";
import { useSelector } from "react-redux";
import {
  setAnalytics,
  initiateAdobeAnalytics,
} from "../../common/Analytics.js";
import { debuglogger } from "../../common/debugLogger";

//--------------------------------------------------------------------//
// All Variables that are set one time at the load of the chat widget
//--------------------------------------------------------------------//
let notificationImgURL;

//--------------------------------------------------------------------//
// All Chat Session Variables that are specific to the current chat
//          conversation and need to be reset when chat ended
//--------------------------------------------------------------------//
let forceInitiate = "false";
let isChatStarted = false; // this flag prevents the multiple execution of action (i.e initiateChat) associated with opening chatWidget.

//--------------------------------------------------------------------//
// All contastant Variables:
//--------------------------------------------------------------------//
//--------------------------------------------------------------------//
//NOTE: do not change const to let for config.
//--------------------------------------------------------------------//

export const config = {
  ChatId: "",
  ConfigKey: "",
  ChatApiURL: "",
  InstanceId: "",
  ContactFlowId: "",
  ChatApiKey: "",
  RegionName: "",
  NameSpace: "",
  isConfigLoaded: false,
  oktaAccessToken: "",
  sfuid: "",
  customerFacing: "true",
  persistChat: "",
  multiChatExpPage: "",
  claimsId: "",
  chatSource: "",
  customerLoginUrl: "",
  customerContactID: "",
  sessionID: "",
  userIdentifier: "",
  userName: "",
  chatDetails: {},
  pageOrigin: "",
};
const imageSrc = "image/notificationSmall.png";

//--------------------------------------------------------------------//
// Chat Widget component Starts Here:
//--------------------------------------------------------------------//
const Chat = ({ initialConfig }) => {
  //Using Redux useSelector and useDispatch to interact with Redux store
  const chatReducer = useSelector((state) => state.chatReducer);
  const messagePaneReducer = useSelector((state) => state.messagePaneReducer);
  const amazonConnectReducer = useSelector(
    (state) => state.amazonConnectReducer
  );
  const dispatch = useDispatch();

  useLayoutEffect(() => {
    if (window.oneX) {
      window.oneX.addElement(failureDivRef.current);
    }
    return () => {
      if (window.oneX) {
        window.oneX.removeElement(failureDivRef);
      }
    };
  });

  const { t, i18n } = useTranslation();
  const changeLanguage = (code) => {
    i18n.changeLanguage(code);
  };

  const divRef = useRef(null);
  const mainDivRef = useRef(null);
  const formInputRef = useRef(null);
  const failureDivRef = useRef(null);

  // Adding Azure AD Authorization for Internal users
  const { instance, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  //------------------------------------------------------------------------------------------
  // 1st useEffect - will trigger once when the chat widget is loaded in the browser.
  //    happens during the load of the chat button
  //Executes at onload.
  //Register listeners for:
  //  -  "message" event handler to receive message from parent of iframe
  //          Sends a message to parent of iframe to indicate iframe is loaded.
  //  -  "beforeunload" event handler to disconnect seession when script is unloaded
  useEffect(() => {
    debuglogger(
      "CHATLOG : on 1. useEffect - On load of this chat widget js initialConfig: " +
        initialConfig
    );
    notifyParent("AppLoaded-true");

    //below condition is only for automated testing.
    if (initialConfig !== undefined && initialConfig !== null) {
      debuglogger(
        "1. useEffect - inside the if check for initialConfig: " + initialConfig
      );
      config.ConfigKey = initialConfig.ConfigKey;
      config.userName = initialConfig.customerName;
      config.sfuid = initialConfig.sfuid;
      config.userIdentifier = initialConfig.customerIdentifier;
      config.persistChat = initialConfig.persistChat;
      config.multiChatExpPage = initialConfig.multiChatExpPage;
      config.customerFacing =
        initialConfig.customerFacing === undefined
          ? config.customerFacing
          : config.customerFacing;
      if (
        config.customerFacing === "true" /*|| config.chatSource === "ECRM"*/
      ) {
        dispatch(
          renderChat({
            from: "01",
            loaderPane: { loaderMessage: "loadingChat" },
          })
        );
      }
      config.additionalAttributes = initialConfig.additionalAttributes;
      config.claimsId = initialConfig.claimsId;
    }

    dispatch(
      setChatParmLanguage({
        language: "en",
        changeLanguage: (language) => changeLanguage(language),
      })
    );
    if (!notificationImgURL) {
      downloadImage(imageSrc).then((sourceImageURL) => {
        notificationImgURL = sourceImageURL;
      });
    }

    // document.addEventListener("visibilitychange", () => {
    //   if (document.visibilityState === "visible") {
    //     dispatch(resetUnreadNotif());
    //   }
    // });

    window.addEventListener("beforeunload", handleWindowBeforeUnloadEvent);
    debuglogger("1. Added new beforeunload listener");
    window.addEventListener("message", handleWindowParentMessageEvent);
    debuglogger("1. Added new message listener");
    function handleWindowClick() {
      debuglogger("window click event");
      if (config.azureApi) config.azureApi.focusMFAModal();
    }
    window.addEventListener("click", handleWindowClick, true);

    logger.setSessionLogLevel();
    logger.getSessionLogLevel();

    return () => {
      debuglogger("1. Removing Old Handler message listener");
      window.removeEventListener("message", handleWindowParentMessageEvent);
      window.removeEventListener("click", handleWindowClick);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //------------------------------------------------------------------------------------------
  // This use effect is use to Azure MFA, when the MFA window is on it will display the erroMessage
  // below and once the MFA window is closed it will clear error on the chat

  useEffect(() => {
    debuglogger(
      "AzureAPI: useffect:\n" +
        "isConfigLoaded: " +
        config?.isConfigLoaded +
        "\n" +
        "customerFacing: " +
        config?.customerFacing +
        "\n" +
        "inProgress: " +
        inProgress +
        "\n" +
        "isAuthenticated: " +
        isAuthenticated +
        "\n"
    );

    if (config.isConfigLoaded && config.customerFacing === "false") {
      //https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/events.md#table-of-events
      if (inProgress === "ssoSilent") {
        //other  values: startup, handleRedirect
        dispatch(
          renderChat({
            from: "02",
            loaderPane: {
              loaderMessage: "userVerificationInProgress",
            },
          })
        );
      }
      if (inProgress === "login") {
        if (!amazonConnectReducer.chatConnected) {
          dispatch(
            renderChat({
              from: "02",
              loaderPane: {
                loaderMessage: "userVerificationInProgress",
              },
            })
          );
        } else {
          dispatch(
            setError({
              error: new AzureAuthenticationLoginInprogressError(),
              errorCode: "E001",
            })
          );
        }
      }

      //once successfully completed MFA authentication clear  renderOfChatPane
      if (inProgress === "none" && isAuthenticated) {
        if (!amazonConnectReducer.chatConnected) {
          dispatch(
            renderChat({
              from: "04a",
              loaderPane: { loaderMessage: "chatLoader" },
            })
          );
        } else if (chatReducer.render.errorPane?.errorMessage) {
          dispatch(
            renderChat({
              from: "04b",
              messagePane: { messagePaneReady: true },
            })
          );
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, inProgress]);

  const handleWindowParentMessageEvent = async (event) => {
    debuglogger("CHATLOG : on handleParentMessageEvent " + event?.data);
    let msg = event.data;
    if (typeof msg === "string") {
      if (msg.includes("cwConfiguration")) {
        dispatch(clearMessageList());
        let cwConfiguration = parseParentMessage(msg);
        config.ConfigKey = cwConfiguration.configKey;
        config.sfuid = cwConfiguration.sfuid;
        config.ChatId = cwConfiguration.herculesChatInstanceId;
        dispatch(
          setChatParmLanguage({
            language: cwConfiguration.language,
            changeLanguage: (language) => changeLanguage(language),
          })
        );
        config.claimsId = cwConfiguration.claimsId;
        config.chatSource = cwConfiguration.chatSource;
        const parentUrl = cwConfiguration.parentUrl.split("?");
        config.pageOrigin = parentUrl[0];
        if (cwConfiguration.customerFacing === "true") {
          config.customerLoginUrl =
            process.env.REACT_APP_LOGIN_LINK + "?goto=" + parentUrl[0];
          config.userName = cwConfiguration.customerName;
          config.persistChat = cwConfiguration.persistChat;
          config.multiChatExpPage = cwConfiguration.multiChatExpPage;
          config.userIdentifier = cwConfiguration.customerIdentifier;
          config.customerFacing = cwConfiguration.customerFacing;
        } else {
          config.customerFacing = "false";
        }
        config.additionalAttributes = cwConfiguration?.additionalAttributes;
        config.additionalAttributes = {
          ...config.additionalAttributes,
          contactStartPage: config.additionalAttributes.contactStartPage
            ? config.additionalAttributes.contactStartPage
            : config.pageOrigin.includes("localhost")
            ? "launched from local server"
            : config.pageOrigin, // Add the parent domain here, pass custom value if page.orgin is "localhost"
        };
        dispatch(
          setChatParmEnableTextArea(cwConfiguration.enableTextArea === "true")
        );

        if (cwConfiguration.customerFacing === "true") {
          config.oktaAccessToken = cwConfiguration.oktaAccessToken;
          debuglogger("cwConfiguration" + cwConfiguration);
        }
        if (msg.includes("cwConfigurationOnClick")) {
          notifyParent("ConfigLoadedAfterClick-true");
        } else {
          notifyParent("ConfigLoaded-true");
        }
        sessionStorage.setItem("userId", config.userIdentifier); // use by DYNATRACE_RUM_AGENT
        sessionStorage.setItem(
          "initialContactId",
          config.chatDetails.ContactId
        ); // use by DYNATRACE_RUM_AGENT
        sessionStorage.setItem("configKey", config.ConfigKey); // use by DYNATRACE_RUM_AGENT
      } else if (msg.includes("updateTokenToUnauth-")) {
        var messageData = getDataFromMessage(msg);
        config.oktaAccessToken = messageData;
      } else if (msg.includes("chatWindowOpened")) {
        // condition to load the config on button click and not on a minimize
        if (!isChatStarted) {
          isChatStarted = true;
          const isVersionLatest = await isAppVersionLatest();
          debuglogger("isVersionLatest: " + isVersionLatest);
          if (!isVersionLatest) {
            dispatch(
              setError({
                error: new ChatWidgetVersionMismatchError("Version Mismatch"),
                retryAction: refreshChat,
                errorCode: "E002",
              })
            );

            return false;
          }
          await retryChat();
        }
        dispatch(setChatWidgetOpened(true));
        dispatch(setUnreadMessageCount(0));
        mainDivRef.current.focus();

        if (
          amazonConnectReducer.chatConnected &&
          messagePaneReducer.messageList.length &&
          (chatReducer.render.messagePane || chatReducer.render.loaderPane)
        ) {
          dispatch(
            renderChat({
              from: "29",
              messagePane: { messagePaneReady: true },
            })
          );
        }
      } else if (msg.includes("cwUpdatedAdditionalAttributes-")) {
        let cwUpdatedAdditionalAttributes = JSON.parse(
          msg.replace("cwUpdatedAdditionalAttributes-", "")
        );
        config.additionalAttributes = {
          ...config.additionalAttributes,
          ...cwUpdatedAdditionalAttributes,
        };
      } else if (msg.includes("cwReplaceAdditionalAttributes-")) {
        let cwReplaceAdditionalAttributes = JSON.parse(
          msg.replace("cwReplaceAdditionalAttributes-", "")
        );
        config.additionalAttributes = {};
        config.additionalAttributes = {
          ...cwReplaceAdditionalAttributes,
        };
        config.ConfigKey = cwReplaceAdditionalAttributes.flowConfigKey;
      } else if (msg.includes("callScrubbingService#@")) {
        let messages = event.data.split("#@");
        config.oktaAccessToken = messages[1];
        dispatch(scrubMessageFromInputContainer(true));
      }
      /* else if (msg.includes("cwUpdateConfigKey-")) {
        let cwUpdateConfigKey = msg.replace("cwUpdateConfigKey-", "");
        config.ConfigKey = cwUpdateConfigKey;
      }  */
      dispatch(resetUnreadNotif());
    }
  };

  const getDataFromMessage = (messageFromParent) => {
    var messageData = messageFromParent.replace("updateTokenToUnauth-", "");
    return messageData;
  };
  // used when customerFacing = false and chatSource !== ECRM to allow the chat to disconnect when changing pages/tabs
  const handleWindowBeforeUnloadEvent = (event) => {
    logger.info("handleWindowBeforeUnloadEvent triggered with event", event);
    const activeElement = event.target?.activeElement;
    uploadChatLogs(config, {
      eventStr: "onHandleWindowBeforeUnloadEvent",
      event: JSON.stringify(event),
    });
    logger.info(
      "onbeforeunload",
      activeElement,
      activeElement?.href,
      activeElement?.protocol
    );

    // document.activeElement.protocol === "mailto:";
    // fix for interactive local development
    // when running local do not do disconnect so the websock is not disconnect everytime the widget is reloaded
    // if (process.env.REACT_APP_VERSION === "local") return;

    if (
      activeElement?.protocol !== "mailto:" &&
      activeElement?.protocol !== "tel:" &&
      config.customerFacing === "false" &&
      config.chatSource !== "ECRM"
    ) {
      if (dispatch(endConnectParticipant(false, false))) {
        var x = 200;
        var a = new Date().getTime() + x;
        //add delay of 200 ms
        while (new Date().getTime() < a) {
          if (event.returnValue) delete event["returnValue"];
        }
      }
    }
  };

  //Call API to initiate Chat. Returns response with participant token.
  const initiateChat = async () => {
    debuglogger("initiateChat call");
    if (config.customerFacing === "false" && config.chatSource !== "ECRM") {
      forceInitiate = "true";
    }
    // added to stop persist when persistChat is false
    if (
      config.customerFacing === "true" &&
      config.multiChatExpPage === "true"
    ) {
      forceInitiate = "true";
    }

    try {
      const response = await initiateChatMethod(config, forceInitiate);
      // Setting force as false on the getting the response
      forceInitiate = "false";
      config.userIdentifier = response.body?.data?.username;
      config.chatDetails = response.body.data.startChatResult;
      config.customerContactID = config.chatDetails.ContactId;
      debuglogger("customerContactID: " + config?.chatDetails?.ContactId);
    } catch (error) {
      console.error("initiate error", error);
      dispatch(
        setError({ error: error, retryAction: initiateChat, errorCode: "E003" })
      );
      //add if statement here
      notifyParent("LiteAuth-failed");
      notifyParent("Connected-false");
      return;
    }

    dispatch(startConnectParticipant(config, retryChat, endChatComplete));
  };

  const retryChat = async (event) => {
    logger.info("Entered retryChat()", event);
    notifyParent("ChatWindowOpen");
    // Only execute endChatComplete when the retry button is clicked.
    // retry function is called from intial chat buttom click or from error page or preform page
    // event will be only defined when retry button is clicked from the error page, other places when retry is called, event is undefined
    if (event) {
      event.preventDefault();
      endChatComplete(true); // only execute endChatComplete when the retry button is clicked.
    }
    if (config.claimsId !== "null" && config.claimsId !== "")
      dispatch(setChatSubtitle("Claims ID: " + config.claimsId));
    const logLevel = logger.getSessionLogLevel();
    dispatch(
      renderChat({
        from: "19",
        loaderPane: { loaderMessage: "chatConfigLoading" },
      })
    );
    //keeping -renders chat loading screen
    try {
      const newConfig = await getArcConfig(config);
      Object.keys(newConfig).forEach((key) => {
        config[key] = newConfig[key];
      });
    } catch (error) {
      config.isConfigLoaded = false;
      dispatch(
        setError({ error: error, retryAction: retryChat, errorCode: "E011" })
      );
      return false;
    }

    if (
      config?.isConfigLoaded &&
      config?.customerFacing === "true" &&
      (!config?.userName || config?.userName === "")
    ) {
      dispatch(renderChat({ from: "21", preChatForm: { name: undefined } }));
      return false;
    } else if (config.isConfigLoaded && config.customerFacing === "false") {
      config.azureApi = config.azureApi
        ? config.azureApi
        : new AzureAPI({
            instance,
            graphScopes: graphConfig.scopes,
            apiScopes: privateChatApi.scopes,
          });
      try {
        const response = await config.azureApi.getUserIdentity();
        debuglogger(" getUserIdentity:" + response);
        config.userIdentifier = response.userIdentifier;
        config.userName = response.userName;
      } catch (error) {
        console.error("catch Error on getUserIdentity()", {
          isAuthenticated,
          error,
          errorString: error.toString(),
        });
        dispatch(
          setError({ error: error, retryAction: retryChat, errorCode: "E012" })
        );
        return false;
      }
    }

    if (
      config.userName?.length &&
      config.userIdentifier?.length &&
      (messagePaneReducer.messageList.length === 0 ||
        !amazonConnectReducer.chatConnected)
    ) {
      sessionStorage.setItem("userId", config.userIdentifier); // use by DYNATRACE_RUM_AGENT
      if (config.customerFacing === "true") {
        dispatch(setChatParmEnableTextArea(config.customerFacing === "true"));
      }
      dispatch(setChatHeaderTitle(t("welcome.label") + ", " + config.userName));
      dispatch(
        renderChat({
          from: "08",
          loaderPane: { loaderMessage: "chatLoader" },
        })
      );
      //keep renders chatLoader
      setAnalytics(config);
      initiateAdobeAnalytics();
      initiateChat();
    } else {
      dispatch(
        setError({
          error: new UnKnownError("UnknownError"),
          retryAction: retryChat,
          errorCode: "E013",
        })
      );
    }

    return false;
  };

  //create a cookie to use, auto open the chat window, clear the cookie again
  const refreshChat = async (event) => {
    notifyParent("refreshAndAutoOpenChat");
    debuglogger("refreshed chat");
    return false;
  };

  // Minimize Chat
  const minimizeChat = (event) => {
    event.preventDefault();
    notifyParent(
      "minimizeChat-true-" + messagePaneReducer.isChatEnabled.isNetworkError
    );
    dispatch(setChatWidgetOpened(false));
    notifyParent({ message: "hideChat", value: "hide" });
  };

  //End Chat when user clicks on End Chat button
  const endChat = (event) => {
    event.preventDefault();
    if (
      messagePaneReducer.isChatEnabled.isConnectParticipantTokenInvalid ||
      messagePaneReducer.isChatEnabled.restartFlag ||
      (config.customerFacing === "false" &&
        messagePaneReducer.messageList.length === 0 &&
        (!isAuthenticated || !amazonConnectReducer.chatConnected))
    ) {
      logger.debug("endChat case1", event);
      endChatComplete();
    } else {
      logger.debug("endChat case2", event);
      if (amazonConnectReducer.chatConnected) {
        dispatch(
          renderChat({
            from: "25",
            closeChatDialogBox: {
              endChatPopUp: true,
            },
          })
        );
      } else {
        logger.debug("endChat case3", event);
        endChatComplete();
      }
      return false;
    }
  };

  const onYesToEndChat = (event) => {
    event.preventDefault();
    endChatComplete();
    return false;
  };

  const onNoToEndChat = (event) => {
    event.preventDefault();
    dispatch(
      renderChat({
        from: "27",
        messagePane: { messagePaneReady: true },
      })
    );
  };

  //Complete the End Chat process. called when End Chat promise completes.
  const endChatComplete = async (
    fromRetry = false,
    fromWSSessionEnd = false
  ) => {
    // close the azure popup authentication window if open
    if (config.azureApi) {
      debuglogger("AzureAPI: Close MFA popup ");
      config.azureApi.closeMFAModal();
    }
    // re-render the chat widget
    dispatch(
      renderChat({
        from: "28",
        loaderPane: {
          loaderMessage: "chatEnding",
        },
      })
    );
    // reset all chat global variables
    forceInitiate =
      fromRetry &&
      !messagePaneReducer.isChatEnabled.isConnectParticipantTokenInvalid
        ? "false"
        : "true";
    if (fromRetry === false) {
      notifyParent({ message: "endChat", value: "end" });
    }

    isChatStarted = false;
    // disconnect chat from the websocket if not yet disconnected
    dispatch(endConnectParticipant(fromRetry, fromWSSessionEnd));
  };

  const printChat = (event) => {
    event.preventDefault();
    // apply the language translator before printing
    printChatUtility(messagePaneReducer.messageList, config, t);
  };

  // Post a message to parent of iframe - unread count, app loaded etc..
  //TODO - move to ChatUtil
  const notifyParent = (message) => {
    const newMessage = {
      message: message,
      ChatId: config.ChatId,
    };
    // eslint-disable-next-line no-restricted-globals
    if (parent) parent.postMessage(newMessage, "*");
  };

  //rep chat accepts 1024 characters, Hercules limitation should be upto 1000 chars with 24 buffer characters for the word breakage

  // Using fetchasync

  //--------------------------------------------------------------------//
  // render chat widget:
  //--------------------------------------------------------------------//
  return (
    <div
      id="chatContainerchatContainerId"
      ref={mainDivRef}
      className="chatContainer -oneX"
      role={window.screen.width > 678 ? "" : "dialog"}
      title={window.screen.width > 678 ? "" : "Chat Window Opened"}
    >
      <InfoBar
        minimizeChat={config.chatSource === "ECRM" ? undefined : minimizeChat}
        onClickCloseChatButton={endChat}
      />

      {chatReducer.render.errorPane && (
        <ErrorPage
          //errorCode={renderOfChatPane.errorPane.errorCode}
          error={chatReducer.render.errorPane.error}
          buttonAction={chatReducer.render.errorPane.retryAction}
          linkAction={
            config.pageOrigin.includes("b2b")
              ? "https://b2b.statefarm.com/b2bapp/b2blogin/UI/Login"
              : config.customerLoginUrl
          }
        />
      )}

      {chatReducer.render.loaderPane && (
        <Loader loaderMessage={chatReducer.render.loaderPane.loaderMessage} />
      )}

      {chatReducer.render.preChatForm && (
        <PreChatForm
          userName={config.userName}
          userIdentifier={"userIdentifier"}
          setNameAndInitiateChat={(newNameUser, idUser) => {
            config.userName = newNameUser;
            retryChat();
          }}
          formInputRef={formInputRef}
        />
      )}

      {chatReducer.render.messagePane && (
        <>
          <div
            className="-oneX-row error-notification"
            hidden={
              !messagePaneReducer.isChatEnabled.isNetworkError &&
              !messagePaneReducer.isChatEnabled.restartFlag &&
              !messagePaneReducer.isChatEnabled.isConnectParticipantTokenInvalid
            }
          >
            {notificationImgURL.match(/^[a-zA-Z0-9:.\-\/]*$/) !== null && (
              <img
                src={notificationImgURL}
                className="-oneX-col-2 error-notification-img"
                aria-label="State Farm Logo"
                alt="NotificationImage"
              />
            )}
            {messagePaneReducer.isChatEnabled.isNetworkError && (
              <span className="-oneX-col-10 error-notification-txt">
                {t("lostConnection")}
              </span>
            )}
            {messagePaneReducer.isChatEnabled.restartFlag && (
              <span className="-oneX-col-10 error-notification-txt">
                {t("unexpectedErrMsg3")}
              </span>
            )}
            {messagePaneReducer.isChatEnabled
              .isConnectParticipantTokenInvalid && (
              <span className="-oneX-col-10 error-notification-txt">
                {t("unexpectedErrMsg4")}
              </span>
            )}
          </div>
          <MessageList divRef={divRef} />
          <InputContainer printChat={printChat} />
        </>
      )}

      {chatReducer.render.closeChatDialogBox && (
        <div className="endChatWindow -oneX-row">
          <Watermark />
          <div className="endChatPopUp">
            <div
              className={
                config.customerFacing === "false"
                  ? "insideEndChat"
                  : "insideEndChatCustomerFacing"
              }
            >
              <div className="end-text">
                <p className="endTextStyle endChatSpace">{t("endChatQues")}</p>
              </div>
              <div className="pop-up-buttons">
                <button
                  className="-oneX-btn-secondary -oneX-btn-medium no-button"
                  onClick={(event) => onNoToEndChat(event)}
                >
                  {t("No")}
                </button>
                <button
                  className="-oneX-btn-primary -oneX-btn-medium yes-button"
                  onClick={(event) => onYesToEndChat(event)}
                >
                  {t("Yes")}
                </button>
              </div>
            </div>
          </div>
          {!JSON.parse(config.customerFacing) && (
            <div className="printTranscript">
              <div className="endChat">
                <button
                  type="submit"
                  id="printButtonID"
                  className="-oneX-btn-secondary -oneX-btn-medium print-button endChat"
                  aria-label={t("printButtonMessage")}
                  tabIndex="0"
                  onClick={(event) => printChat(event)}
                >
                  {t("printButtonMessage")}
                </button>
              </div>
              <div className="messageBox">
                <p className="messageStyle">
                  Please ensure sharing or storage of the transcript maintains
                  appropriate confidentiality of the information. As a reminder,
                  State Farm agents are independent contractors who hire their
                  own employees. State Farm agents employees are not employees
                  of State Farm. Agents are responsible for and make all
                  employment decisions regarding their employees.
                </p>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
//--------------------------------------------------------------------//
// Chat Widget component Ends Here.
//--------------------------------------------------------------------//
export default Chat;
